export enum DialogType {
    DeletePitch = "DeletePitch",
    DeletingTeamMember = "DeletingTeamMember",
    DeletingFoundingTeamMember = "DeletingFoundingTeamMember",
    None = "None"
}